<template>
  <div>
    <div class="content">
      <div class="md-layout">
        <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <md-card class="md-card-plain">
            <md-card-header>
              <h4 class="title"><b>Mayai Number Manager</b></h4>
            </md-card-header>
            <md-card-content>
              <template>
                <!-- <div>
                <md-table
                  v-model="params.data"
                  :table-header-color="tableHeaderColor"
                  md-fixed-header
                >
                  <md-table-row slot="md-table-row" slot-scope="{ item, index }">
                    <md-table-cell md-label="ID">{{ index+1 }}</md-table-cell>
                    <md-table-cell md-label="Name" >{{ item[0] }}</md-table-cell>
                    <md-table-cell md-label="Phonetic">{{ item[1] }}</md-table-cell>
                    <md-table-cell md-label="Notification" >{{ item[2] }}</md-table-cell>
                    <md-table-cell md-label="Plam" >{{ item[3] }}</md-table-cell>
                    <md-table-cell md-label="Address">{{ item[4] }}</md-table-cell> 
                    <md-table-cell md-label="City">{{ item[5] }}</md-table-cell>
                    <md-table-cell md-label="Postal Code">{{ item[6] }}</md-table-cell>
                    <md-table-cell md-label="Email">{{ item[7] }}</md-table-cell>
                  </md-table-row>
                </md-table>
              </div> -->
                <div>
                  <vue-table-dynamic
                    :params="params"
                    ref="table"
                  ></vue-table-dynamic>
                </div>
                <div class="md-layout-item md-size-100 text-right">
                  <md-button class="md-raised md-success" @click="exportCSV">
                    <md-icon>download </md-icon>
                    <md-tooltip md-direction="top">Download as CSV</md-tooltip>
                  </md-button>
                </div>
              </template>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
    <div class="loading-overlay" v-if="loading">
      <md-progress-spinner
        md-mode="indeterminate"
        :md-stroke="2"
      ></md-progress-spinner>
    </div>
  </div>
</template>

<script>
import ApiService from "@/services/ApiService";
import VueTableDynamic from "vue-table-dynamic";
import moment from "moment";

export default {
  components: {
    VueTableDynamic
  },
  props: {
    tableHeaderColor: {
      type: String,
      default: "green"
    }
  },
  data() {
    return {
      loading: false,
      numbers: [],
      params: {
        data: [],
        sort: [0, 1, 4, 6],
        header: "row",
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 120 },
          { column: 1, width: 110 },
          { column: 2, width: 100 },
          { column: 3, width: 80 },
          { column: 4, width: 100 },
          { column: 5, width: 300 },
          { column: 6, width: 130 },
          { column: 7, width: 150 }
        ],
        height: 600,
        fixed: 0,
        pagination: true,
        pageSize: 20, // Used when pagination is set to true
        pageSizes: [10, 20, 30, 40, 50], // Used when pagination is set to true
        // rowHeight: 50
        enableSearch: true
      }
    };
  },
  mounted() {
    this.fetchCustomer();
  },
  methods: {
    async fetchCustomer() {
      this.loading = true;
      var responce = await ApiService.fetchMayaiNumberDetails();
      // console.log(responce);

      if (responce.data) {
        this.loading = false;
        this.numbers = responce.data.number_pool;
        this.params.data = [];
        this.params.data.push([
          "050 Number",
          "Price",
          "Type",
          "Rank",
          "Status",
          "Company Name",
          "Company Status",
          "Purchased Date"
        ]);
        await this.numbers.forEach(async num => {
          var display_number = "";
          var price = 0;
          var type = "";
          var rank = "";
          if (num.number) {
            display_number = num.number.display_number;
            price = num.number.price;
            type = num.number.type;
            rank = num.number.rank;
          }
          var company_name = "";
          var company_status = "";
          if (num.company_data) {
            company_name = num.company_data.name;
            company_status = num.company_data.status;
          }

          var purchased_date = "";
          if (num.number_rental_data) {
            purchased_date =
              new Date(num.number_rental_data.purchasedDateTime).getFullYear() +
              "-" +
              (new Date(num.number_rental_data.purchasedDateTime).getMonth() +
                1) +
              "-" +
              new Date(num.number_rental_data.purchasedDateTime).getDate();
          }

          this.params.data.push([
            display_number,
            price,
            type,
            rank,
            num.status,
            company_name,
            company_status,
            purchased_date
          ]);
          // this.params.data.push([comp.name,comp.status,comp.pricing_plan,comp.number, comp.call_data  ? comp.call_data.in_calls : 0]);
        });
        // console.log(Object.assign({}, this.params.data));
      } else {
        this.loading = false;
      }
    },
    exportCSV() {
      var tableHeaders = this.params.data[0];

      var dataTable = new Array();
      dataTable.push(tableHeaders);

      //now looping around the data
      this.params.data.forEach(function(row, index) {
        if (index !== 0) dataTable.push(row);
      });
      // console.log(dataTable.length);

      let csvContent = ""; //"data:text/csv;charset=utf-8,";
      // var i = 0;
      dataTable.forEach(function(rowArray) {
        let row = rowArray.join(",");
        csvContent += row + "\r\n";
        // i++;
      });
      // console.log('i=' + i);
      //calling the csv download via anchor tag(link) so we can provide a name for the file
      var encodedUri =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.style.display = "none";
      link.setAttribute(
        "download",
        "mayai_number_details_" +
          (new Date().getMonth() + 1) +
          "_" +
          new Date().getFullYear() +
          ".csv"
      ); //change it to give your own name
      link.innerHTML = "Export";
      document.body.appendChild(link); // Required for FF

      link.click();
      link.remove(); //removing the link after the download
    }
  }
};
</script>
//
<style lang="scss">
// .md-table.mayai-list .md-table-head {
//     text-align: center;
// }
//
</style>

<style lang="scss">
.centered-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100vh;
}

.loading-overlay {
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
